import moment from "moment";

export const validDate = (value) => {
  return moment(value).isValid();
};
